import { DataTable } from "@/components/data-table"
import { CajaApertura } from "@/shared/types/caja-apertura"
import { Moneda } from "@/shared/types/moneda"
import { StackProps } from "@mui/material"
import { BodyTypography, HeaderTypography } from "./table-typography"
import { formatNumber, formatString } from "@/shared/formats"
import { getTotalMonedaTransferencia } from "@/features/monetizacion/shared/utils"

export interface SharedCajaAperturaTotalTableProps extends StackProps {
    cajaApertura: CajaApertura,
    monedas: Moneda[]
}

export default function SharedCajaAperturaTotalTable({
    cajaApertura,
    monedas,
    ...props
}: SharedCajaAperturaTotalTableProps) {
    return <DataTable {...props}>
        <DataTable.Content
            rows={monedas}
            columns={[
                {
                    header: <HeaderTypography>Totales</HeaderTypography>,
                    render: moneda => <BodyTypography moneda={moneda}>{`${formatString(moneda.nombre)} (${formatString(moneda.simbolo)})`}</BodyTypography>
                },
                {
                    header: <HeaderTypography>Inicial</HeaderTypography>,
                    render: moneda => <BodyTypography moneda={moneda}>
                        {formatNumber(getTotalMonedaTransferencia(cajaApertura.transferenciaInicial, moneda.id))}
                    </BodyTypography>,
                    align: "right",
                    width: "auto"
                },
                {
                    header: <HeaderTypography>Calculado</HeaderTypography>,
                    render: moneda => <BodyTypography moneda={moneda}>
                        {formatNumber(getTotalMonedaTransferencia(cajaApertura.transferenciaTotal, moneda.id))}
                    </BodyTypography>,
                    align: "right",
                    width: "auto"
                },
                cajaApertura.transferenciaReal && {
                    header: <HeaderTypography>Real</HeaderTypography>,
                    render: moneda => <BodyTypography moneda={moneda}>
                        {formatNumber(getTotalMonedaTransferencia(cajaApertura.transferenciaReal!, moneda.id))}
                    </BodyTypography>,
                    align: "right",
                    width: "auto"
                },
                cajaApertura.transferenciaDiferencia && {
                    header: <HeaderTypography>Diferencia</HeaderTypography>,
                    render: moneda => <BodyTypography moneda={moneda}>
                        {formatNumber(getTotalMonedaTransferencia(cajaApertura.transferenciaDiferencia!, moneda.id))}
                    </BodyTypography>,
                    align: "right",
                    width: "auto"
                }
            ]}
        />
    </DataTable>
}